<template>
  <div class="e2e-matrix">
    <input type="hidden" :name="fragment.uuid" :value="fragment.uuid"/>
    <table class="mc-matrix">
      <tr v-for="(row, rowIndex) in fragment.initialValues" :key="rowIndex" class="mc-matrix-row">
        <td v-for="(value, columnIndex) in row" :key="columnIndex" class="mc-matrix-cell">
          <input
            class="form-control form-control-sm"
            v-mc-validate="{ expect: fragment.inputType, allowNoValue: false }"
            :readonly="!fragment.editable" 
            :value="value"
            :name="fragment.uuid + '_' + rowIndex + '_' + columnIndex "
          >
        </td>
      </tr>
    </table>
    <div
      v-if="fragment.semanticInvalid === true"
      style="color: red; margin: 10px 0px 0px 0px;"
      class
    >{{fragment.semanticInvalidMessage}}</div>
  </div>
</template>

<script> 
import "../utils.js"; // v-mc-validate directive

export default {
  name: "fragment-matrix",
  props: ["fragment"] 
};
</script> 
 

<style scoped>
.mc-matrix-cell {
  max-width: 100px;
}
.mc-matrix {
  position: relative;
}
.mc-matrix:before,
.mc-matrix:after {
  content: "";
  position: absolute;
  top: -5px;
  bottom: -5px;
  border: 2px solid blue;
  width: 6px;
}
.mc-matrix:before {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  left: -6px;
  border-right: 0;
}
.mc-matrix:after {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  right: -6px;
  border-left: 0;
}
</style>